import { WorkspaceOnboardingType } from '@baserow/modules/core/onboardingTypes'
import SubscriptionService from '@saas/services/subscriptions'

export class SaaSWorkspaceOnboardingType extends WorkspaceOnboardingType {
  async complete(data, responses) {
    const workspace = await super.complete(data, responses)
    await SubscriptionService(this.app.$client).startTrial(workspace.id)
    // This fetches the active licenses again, so that the user immediately has access
    // to free trial features.
    await this.app.store.dispatch('auth/refresh')
    await this.app.store.dispatch('saasApp/setShowFreeTrialStep', true)
    return workspace
  }
}
